import React from 'react';
import styled from 'styled-components';

import { IApplication } from '../../models';
import { BackButton, NextButton } from './NavigationButton';

const NavigationCounter = styled.span`
    align-self: center;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 104px 0px 104px 0px;
`;

interface IProps {
  application: IApplication | null;
  stepIndex: number;
  inputs: Map<string, string>;
  handlePreviousClick: () => void;
  handleNextClick: () => void;
}

class StepNavigation extends React.Component<IProps> {

  render() {
    const { application,
      stepIndex,
      inputs,
      handlePreviousClick,
      handleNextClick } = this.props;

    if (!application) return null;

    const isBackDisabled = () => {
      return false;
    };

    const isNextDisabled = () => {
      const optionalFilterRating = 'Rating';
      const step = application.steps[stepIndex];
      const filterKeys = step.filters.map((filter) => {
        return {
          key: filter.key
        };
      });

      if (step.name === optionalFilterRating) {
        return false;
      }

      if (filterKeys.length === 0) return true;

      let isDisabled = false;

      filterKeys.forEach((x) => {
        if (!inputs.has(x.key) || inputs.get(x.key) === '') isDisabled = true;
      });

      return isDisabled;
    };

    return (
      <Container>
        <div>
          <BackButton
            type="button"
            onClick={handlePreviousClick}
            disabled={isBackDisabled()}
          >
            Back
          </BackButton>
        </div>
        <NavigationCounter>{stepIndex + 1}/{application.steps.length}</NavigationCounter>
        <div>
          <NextButton type="button" onClick={handleNextClick} disabled={isNextDisabled()}>Next</NextButton>
        </div>
      </Container>
    );
  }
}

export default StepNavigation;
